import { client } from "api";
import { InstallerInformation } from "models/Users";

export type GetInstallersResponse = InstallerInformation[];

export const getInstallers = (): Promise<GetInstallersResponse> =>
  client.get<GetInstallersResponse>(`/user/get-all-installers`).then((res) => res.data);
